<template>
  <div class="container">
    <div class="row mt-lg-n10 mt-md-n11 mt-n10 justify-content-center">
      <div class="mx-auto col-xl-4 col-lg-5 col-md-7">
        <div class="card z-index-0 mt-10">
          <div class="card-body">
            <soft-badge
              color="warning"
              variant="gradient"
              size="sm"
              @click="$emit('close-edit-form')"
              class="cursor-pointer float-right"
            >
              {{ $t("global.close") }}
            </soft-badge>
            <p class="my-3 text-bold">
              {{ $t("subcourses.editingSubcourse") }}
            </p>

            <form @submit.prevent="submitForm">
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0">{{
                  $t("subcourses.subcourseTitle")
                }}</span>
                <InputForm
                  v-model="formData.title"
                  :placeholder="localSubcourse.title"
                  type="text"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0">{{
                  $t("subcourses.coursePrice")
                }}</span>
                <InputForm
                  v-model="formData.price"
                  :placeholder="localSubcourse.price"
                  type="number"
                />
              </div>

              <div class="mb-3">
                <span class="text-xs text-secondary mb-0">{{
                  $t("subcourses.numberOfMonths")
                }}</span>
                <InputForm
                  v-model="formData.number_of_months"
                  :placeholder="localSubcourse.number_of_months"
                  type="number"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0">{{
                  $t("courses.selectCourse")
                }}</span>
                <SelectFormCourse
                  @select="getCourse"
                  v-model="courses"
                  :selectedOption="localSubcourse.course.title"
                />
              </div>
              <div class="mb-3">
                <span class="text-xs text-secondary mb-0">{{
                  $t("subcourses.startFrom")
                }}</span>
                <DatePicker
                  v-model="formData.start_date"
                  :placeholder="localSubcourse.start_date"
                />
              </div>
              <div class="text-center">
                <soft-button
                  color="dark"
                  full-width
                  variant="gradient"
                  class="my-4 mb-2"
                >
                  {{ $t("global.edit") }}
                </soft-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InputForm from "@/components/InputForm.vue";
import SelectFormCourse from "@/components/SelectFormCourse.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import DatePicker from "@/components/DatePicker.vue";
import swal from "sweetalert2";

export default {
  name: "FormCreateTeacher",
  components: {
    InputForm,
    SelectFormCourse,
    SoftButton,
    SoftBadge,
    DatePicker,
  },
  props: {
    subcourse: {
      type: Object,
      require: true,
    },
  },
  created() {
    this.getCourses();
  },
  data() {
    return {
      formData: {
        id: null,
        title: "",
        course_id: null,
        price: "",
        number_of_months: "",
        start_date: "",
      },
      courses: [],
      selectedCourse: null,
      localSubcourse: { ...this.subcourse },
    };
  },
  methods: {
    async submitForm(event) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("_method", "PATCH");
      formData.append("id", this.localSubcourse.id);
      if (this.formData.title != "") {
        formData.append("title", this.formData.title);
      }
      if (this.formData.price != "") {
        formData.append("price", this.formData.price);
      }
      if (this.formData.start_date != "") {
        formData.append("start_date", this.formData.start_date);
      }
      if (this.formData.number_of_months != "") {
        formData.append("numberOfMonths", this.formData.number_of_months);
      }
      if (this.formData.course_id != null) {
        formData.append("course_id", this.formData.course_id);
      }

      try {
        await axios.post("subcourse/" + this.localSubcourse.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        this.resetForm();
        this.$emit("close-edit-form");
        swal.fire({
          icon: "success",
          title: this.$t("subcourses.subcourseUpdated"),
          showConfirmButton: false,
          timer: 2000,
        });
        
      } catch (error) {
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          let errorMessages = "";

          if (typeof errors === "function") {
            for (const key in errors) {
              if (errors.prototype.hasOwnProperty.call(errors, key)) {
                errorMessages += `- ${errors[key].join(", ")}\n`;
                swal.fire({
                  title: this.$t("global.error"),
                  html: errorMessages.replace(/\n/g, "<br>"),
                  icon: "error",
                  position: "top-end",
                });
              }
            }
          } else {
            for (const key in errors) {
              errorMessages += `- ${errors[key].join(", ")}\n`;
              swal.fire({
                title: this.$t("global.error"),
                html: errorMessages.replace(/\n/g, "<br>"),
                icon: "error",
                position: "top-end",
              });
            }
          }
        }
      }
    },
    async getCourses() {
      const response = await axios.get("courses/all");
      this.courses = response.data.courses;
    },
    getCourse(selectedCourse) {
      this.formData.course_id = selectedCourse;
    },
    resetForm() {
      this.formData.title = "";
      this.formData.course_id = null;
      this.formData.price = "";
      this.formData.start_date = "";
      this.formData.number_of_months = "";

      return;
    },
  },
  watch: {
    subcourse(newSubcourse) {
      this.localSubcourse = { ...newSubcourse };
    },
  },
};
</script>

<style scoped>
.custom-file-upload {
  display: inline-block;
  padding: 10px 20px;
  cursor: pointer;
  background: linear-gradient(to right, #7fe02f, #2cb735);
  color: white;
  border-radius: 8px;
}
#file {
  display: none;
}
.custom-file-upload span {
  pointer-events: none;
}
.float-right {
  float: right;
}
</style>
